// extracted by mini-css-extract-plugin
export default {"reminder":"style_reminder__dEuH9"};